var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPCoolingChillerTem = function SvgPCoolingChillerTem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 69.1,
    y1: 381.1,
    x2: 69.1,
    y2: 386.6,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.6,
    y: 383.6,
    width: 3,
    height: 15,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,384.1v14h-2v-14H58.1 M59.1,383.1h-4v16h4V383.1L59.1,383.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 79.6,
    y: 383.6,
    width: 3,
    height: 15,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,384.1v14h-2v-14H82.1 M83.1,383.1h-4v16h4V383.1L83.1,383.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.6,
    y: 386.6,
    width: 21,
    height: 9,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,387.1v8h-20v-8H79.1 M80.1,386.1h-22v10h22V386.1L80.1,386.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,386.5c-2.6,1.8-6.4,2.8-9.9,2.8s-7.3-1-9.9-2.8",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,395.6c-2.6-1.8-6.4-2.8-9.9-2.8s-7.3,1-9.9,2.8",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.6,
    y: 359.6,
    width: 21,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,360.1v20h-20v-20H79.1 M80.1,359.1h-22v22h22V359.1L80.1,359.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,367.3h1.1l-2,5.7h-1l-2.1-5.7h1.1l1.4,4.5C69.1,371.7,70.5,367.3,70.5,367.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 90.2,
    y1: 365.1,
    x2: 84.6,
    y2: 365.1,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.6,363.6 80.2,365.1 85.6,366.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 90.2,
    y1: 375.1,
    x2: 84.6,
    y2: 375.1,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.6,373.6 80.2,375.1 85.6,376.5"
  })))));
};
export default SvgPCoolingChillerTem;